import type { Size } from './input-size'

export const RADIUS_MAP: Record<Size, number> = {
  s: 10,
  m: 10,
  l: 10,
  h28: 8,
  h32: 8,
  h36: 10,
  h40: 10,
  h50: 12,
}

export const HEIGHT_MAP: Record<Size, number> = {
  m: 42,
  s: 36,
  l: 48,
  h28: 28,
  h32: 32,
  h36: 36,
  h40: 40,
  h50: 50,
}

export const FONT_SIZE_MAP: Record<Size, number> = {
  l: 11,
  m: 12,
  s: 10,
  h28: 10,
  h32: 11,
  h36: 12,
  h40: 13,
  h50: 14,
}

export const FONT_WEIGHT_MAP: Record<Size, number> = {
  l: 700,
  m: 600,
  s: 600,
  h28: 500,
  h32: 500,
  h36: 500,
  h40: 500,
  h50: 500,
}
